<!-- Survey creation page -->
<section class="mt-3">
  <kl-create-survey
    [creationPayload]="extraCreationPayload"
    (surveyCreated)="onSurveyCreation($event)">
  </kl-create-survey>
</section>
<!-- / Survey creation page -->
